<div
  *ngIf="showInvoiceAlert"
  class="fixed inset-0 bg-black/40 flex items-center justify-center z-[9999]"
>
  <div
    class="bg-white/95 backdrop-blur-md p-6 rounded-2xl shadow-2xl w-[350px] flex flex-col gap-4 animate-fadeIn relative"
  >
    <button
      (click)="closeInvoiceAlert()"
      class="absolute top-3 right-3 text-gray-400 hover:text-gray-600 transition"
      title="Close"
    >
      <i class="fa-solid fa-xmark text-lg"></i>
    </button>

    <div class="flex items-center justify-center w-14 h-14 rounded-full bg-blue-100 mx-auto">
      <i class="fa-solid fa-check text-blue-600 text-2xl"></i>
    </div>

    <span class="text-blue-700 font-bold text-lg text-center">{{
      'invoice.success' | translate
    }}</span>

    <div class="flex items-center justify-center gap-2 text-gray-700 text-sm">
      <span
        >{{ 'invoice.no' | translate }} <strong>{{ invoiceNo }}</strong></span
      >
      <button
        (click)="copyInvoiceAlert()"
        class="p-2 border border-gray-300 text-[var(--primary)] rounded-md hover:bg-[var(--primary)] hover:text-white transition"
        title="Copy Invoice"
      >
        <i class="fa-solid fa-copy"></i>
      </button>
    </div>
  </div>
</div>

<div class="main-container">
  <div class="navbar flex items-center justify-between gap-1 px-2 sm:px-4 md:px-5 py-2 sm:py-3">
    <div class="flex items-center gap-1 sm:gap-2 md:gap-3 flex-1 min-w-0">
      <img src="https://ts-space.sgp1.digitaloceanspaces.com/uploads/lottery/admin/image/ae09640b-f4dd-4d6e-89ed-727834ba8d1e-logo.png" alt="Logo" class="logo w-8 h-8 sm:w-10 sm:h-10 md:w-[50px] md:h-[50px] object-contain flex-shrink-0" />
      <h3 class="text-sm sm:text-lg md:text-2xl font-bold whitespace-normal leading-tight">{{ 'nav.title' | translate }}</h3>

      <div class="lang-pill ml-1 sm:ml-2 md:ml-4 flex-shrink-0">
        <i class="fa-solid fa-globe globe-icon"></i>
        <button
          (click)="setLanguage('en')"
          [class.active]="currentLang() === 'en'"
          class="lang-item"
        >
          EN
        </button>
        <div class="lang-divider"></div>
        <button
          (click)="setLanguage('mm')"
          [class.active]="currentLang() === 'mm'"
          class="lang-item"
        >
          MM
        </button>
      </div>
    </div>

    <div class="flex gap-1.5 sm:gap-4 md:gap-6 items-center flex-shrink-0">
      <button
        class="bg-[var(--primary)] text-white px-2.5 py-1.5 sm:px-6 md:px-10 rounded-lg text-xs md:text-sm font-medium shadow-md hover:bg-[var(--primary-hover)] transition duration-200 cursor-pointer flex items-center justify-center"
        (click)="success()"
        [title]="'nav.purchase' | translate"
      >
        <i class="fa-solid fa-file md:me-1"></i>
        <span class="hidden md:inline">{{ 'nav.purchase' | translate }}</span>
      </button>

      <button
        [disabled]="selectedTickets.length === 0"
        [style.background-color]="selectedTickets.length === 0 ? '#9ca3af' : 'var(--primary)'"
        class="text-white px-2.5 py-1.5 sm:px-6 md:px-8 rounded-lg text-xs md:text-sm font-medium shadow-md hover:bg-[var(--primary-hover)] transition duration-200 cursor-pointer flex items-center justify-center"
        (click)="openPaymentModal()"
        [title]="'nav.ticket' | translate"
      >
        <i class="fa-solid fa-cart-shopping md:me-1"></i>
        <span class="hidden md:inline">{{ 'nav.ticket' | translate }}</span>
        <span class="ml-1 font-bold">({{ selectedTickets.length }})</span>
      </button>
    </div>
  </div>

  <div class="w-full flex flex-col md:flex-row md:h-[calc(100vh-67px)]">
    <div class="w-full md:w-[35%] px-5 py-4 md:h-full flex flex-col">
      <div
        *ngIf="loadingResult"
        class="skeleton-loader w-full h-[300px] md:h-full rounded-2xl shadow-lg"
      ></div>

      <img
        *ngIf="!loadingResult && result?.image"
        [src]="result.image"
        [alt]="result.image"
        class="w-full h-auto md:h-full rounded-2xl shadow-lg object-contain"
      />

      <div
        *ngIf="!loadingResult && !result?.image"
        class="w-full h-[300px] md:h-full bg-gray-100 rounded-2xl flex items-center justify-center text-gray-400 border-2 border-dashed border-gray-200"
      >
        <div class="text-center">
          <i class="fa-solid fa-image text-4xl mb-2"></i>
          <p class="text-sm">{{ 'ticket.noResultImage' | translate }}</p>
        </div>
      </div>
    </div>

    <div class="hidden md:block w-px bg-black self-stretch"></div>

    <div class="w-full md:w-[65%] md:min-h-[calc(100vh-67px)] px-5 py-4 relative flex flex-col">
      @if (loadingService.loading$ | async) {
      <div class="loading-overlay">
        <app-loading></app-loading>
      </div>
      }

      <div class="about-accordion mb-3">
        <button
          class="about-accordion-trigger"
          (click)="toggleAboutUs()"
          id="about-us-trigger"
        >
          <span class="about-accordion-title">ကျွန်ုပ်တို့အကြောင်း (About Us)</span>
          <svg
            class="about-chevron"
            [ngClass]="{ 'rotated': aboutUsOpen }"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
          </svg>
        </button>

        <div class="about-accordion-body" [class.open]="aboutUsOpen">
          <div class="about-accordion-content">
            <p class="about-para">"တအာင်းပညာရေးရန်ပုံငွေထီ" သည် တအာင်းဒေသအတွင်း ပညာရေးဖွံ့ဖြိုးတိုးတက်စေရန် ရည်ရွယ်၍ ဖန်တီးတည်ထောင်ထားသော လူမှုအကျိုးပြု အစီအစဉ်တစ်ရပ်ဖြစ်ပါသည်။</p>
            <p class="about-para">တအာင်းဒေသတွင်းရှိ ကျောင်းများ၏ အဆောက်အဦးလိုအပ်ချက်များ၊ သင်ကြားရေးပစ္စည်းမလုံလောက်မှုများနှင့် ဆရာ/ဆရာမအင်အားကန့်သတ်မှုများကြောင့် ပညာရေးကဏ္ဍသည် စိန်ခေါ်မှုများစွာနှင့် ရင်ဆိုင်နေရပါသည်။</p>
            <p class="about-para">ထိုအခက်အခဲများကို ဖြေရှင်းနိုင်ရန်နှင့် ဒေသခံလူငယ်များအတွက် ပိုမိုကောင်းမွန်သော ပညာရေးအခွင့်အလမ်းများဖန်တီးပေးရန် "တအာင်းပညာရေးရန်ပုံငွေထီ" ကို စတင်ခဲ့ခြင်းဖြစ်ပါသည်။</p>
            <p class="about-para about-leads">ထီမှရရှိသော ဝင်ငွေများကို—</p>
            <ul class="about-bullets">
              <li>🏫 ကျောင်းအဆောက်အဦးများ ပြုပြင်တည်ဆောက်ခြင်း</li>
              <li>📚 သင်ကြားရေးပစ္စည်းများ ပံ့ပိုးပေးခြင်း</li>
              <li>👩 ဆရာ၊ ဆရာမများအား ထောက်ပံ့ကူညီခြင်း</li>
              <li>🎓 ကျောင်းသား၊ ကျောင်းသူများ၏ ပညာရေးလိုအပ်ချက်များ ဖြည့်ဆည်းပေးခြင်း</li>
            </ul>
          </div>
        </div>
      </div>


      <div class="w-full flex flex-col sm:flex-row gap-3 sm:gap-4">
        <div class="relative w-full sm:flex-1">
          <div
            id="alphabet-trigger"
            (click)="toggleDropdown()"
            class="border border-gray-400 px-3 py-2 rounded-lg text-sm cursor-pointer flex justify-between items-center hover:border-[var(--primary)] transition"
          >
            <span>
              {{
                selectedAlphabet === 'ALL' || !selectedAlphabet
                  ? ('ticket.allAlphabets' | translate)
                  : selectedAlphabet
              }}
            </span>

            <svg
              class="w-4 h-4 transition-transform"
              [ngClass]="{ 'rotate-180': dropdownOpen }"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </div>

          <div
            id="alphabet-dropdown"
            *ngIf="dropdownOpen"
            class="absolute mt-2 w-full bg-white border border-gray-300 rounded-xl shadow-xl z-50 grid grid-cols-6 gap-2 p-4 animate-fadeIn"
          >
            <div
              *ngFor="let letter of alphabets"
              (click)="selectAlphabet(letter)"
              class="text-center py-1 rounded-md cursor-pointer hover:bg-[var(--primary)] hover:text-white transition text-sm"
            >
              {{ letter }}
            </div>
          </div>
        </div>

        <input
          type="text"
          class="w-full sm:flex-1 border border-gray-400 focus:border-[var(--primary)] focus:outline-none px-3 py-2 rounded-lg text-sm"
          [(ngModel)]="searchNumber"
          (input)="searchTickets()"
          [placeholder]="'ticket.number' | translate"
        />

        <select
          class="w-full sm:flex-1 border border-gray-400 focus:border-[var(--primary)] focus:ring-2 focus:ring-[var(--primary)]/20 focus:outline-none px-3 py-2 rounded-lg text-sm transition"
          [(ngModel)]="selectedCount"
          (ngModelChange)="onCountChange($event)"
        >
          <option [ngValue]="null">{{ 'ticket.randomTickets' | translate }}</option>

          <option [ngValue]="0">0</option>
          <option *ngFor="let count of ticketCounts" [ngValue]="count">
            {{ count }}
          </option>
        </select>
      </div>

      <div class="flex flex-col flex-1 min-h-0">
        <div
          class="flex-1 overflow-auto w-full mt-2 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 sm:gap-4 content-start"
          [class.loading-active]="loadingService.loading$ | async"
        >
          <div
            *ngFor="let ticket of displayTickets"
            (click)="toggleTicket(ticket)"
            class="border rounded-lg text-center text-sm cursor-pointer h-[38px] flex items-center justify-center px-3 sm:px-4 transition-colors duration-200"
            [ngClass]="{
              'bg-[var(--primary)] text-white border-[var(--primary)]': isSelected(ticket.id),
              'bg-white border-gray-400 text-black': !isSelected(ticket.id)
            }"
          >
            {{ ticket.code }}
          </div>
        </div>

        <div
          class="flex flex-col sm:flex-row justify-between items-center gap-4 py-6 border-t border-gray-100 mt-auto bg-white px-4"
        >
          <div class="flex items-center gap-3 order-2 sm:order-1">
            <span class="text-xs font-semibold uppercase tracking-wider text-gray-400">{{
              'ticket.show' | translate
            }}</span>
            <div class="relative">
              <select
                [(ngModel)]="ticketsPerPage"
                (ngModelChange)="onLimitChange()"
                class="appearance-none bg-gray-50 border border-gray-200 text-gray-700 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2 pr-8 cursor-pointer hover:bg-gray-100 transition-all"
              >
                <option [ngValue]="4">4</option>
                <option [ngValue]="8">8</option>
                <option [ngValue]="12">12</option>
                <option [ngValue]="16">16</option>
                <option [ngValue]="20">20</option>
                <option [ngValue]="28">28</option>
                @if (selectedCount != null) {
                  <option [ngValue]="selectedCount">{{selectedCount}}</option>
                }
              </select>
              <div
                class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-500"
              >
                <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </div>
            </div>
          </div>

          <nav
            class="flex items-center -space-x-px rounded-md shadow-sm order-1 sm:order-2"
            aria-label="Pagination"
          >
            <button
              (click)="goToPage(currentPage - 1)"
              [disabled]="currentPage === 1"
              class="relative inline-flex items-center rounded-l-md px-3 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0 disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
            >
              <span class="sr-only">Previous</span>
              <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path
                  fill-rule="evenodd"
                  d="M12.79 5.23a.75.75 0 01-.02 1.06L8.832 10l3.938 3.71a.75.75 0 11-1.04 1.08l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 011.06.02z"
                  clip-rule="evenodd"
                />
              </svg>
            </button>

            <ng-container *ngFor="let page of visiblePages; let i = index">
              <button
                (click)="page !== '...' && goToPage($any(page))"
                [disabled]="page === '...'"
                [ngClass]="{
                  'z-10 bg-[var(--primary)] text-white ring-1 ring-inset ring-[var(--primary)]':
                    currentPage === page,
                  'text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-100':
                    currentPage !== page && page !== '...',
                  'text-gray-400 cursor-default ring-0': page === '...'
                }"
                class="relative inline-flex items-center px-4 py-2 text-sm font-semibold focus:outline-offset-0 transition-all"
              >
                {{ page }}
              </button>
            </ng-container>

            <button
              (click)="goToPage(currentPage + 1)"
              [disabled]="currentPage === totalPages"
              class="relative inline-flex items-center rounded-r-md px-3 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0 disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
            >
              <span class="sr-only">Next</span>
              <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path
                  fill-rule="evenodd"
                  d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z"
                  clip-rule="evenodd"
                />
              </svg>
            </button>
          </nav>
        </div>
      </div>
    </div>
  </div>

  <div
    *ngIf="showPaymentModal"
    class="fixed inset-0 bg-gray-700/70 flex items-center justify-center z-[1000]"
  >
    <div
      class="bg-white w-[95%] max-w-xl rounded-2xl shadow-2xl p-5 relative animate-fadeIn max-h-[90vh] overflow-y-auto sm:w-[95%] sm:max-w-xl mobile-full"
    >
      <h2 class="text-xl font-bold text-center text-gray-800 mb-6 mt-1">Payment Summary</h2>

      <div class="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-6">
        <div class="relative">
          <input
            type="text"
            [(ngModel)]="paymentName"
            [class.border-red-500]="paymentSubmitted && !paymentName"
            [class.bg-red-50]="paymentSubmitted && !paymentName"
            class="w-full border border-gray-400 rounded-lg px-3 py-2 text-xs focus:border-[var(--primary)] focus:outline-none transition"
            placeholder="Name"
          />
          <p *ngIf="paymentSubmitted && !paymentName" class="text-[10px] text-red-500 mt-1 px-1 animate-fadeIn">
            Name is required
          </p>
        </div>
        <div class="relative">
          <input
            type="text"
            [(ngModel)]="paymentAddress"
            [class.border-red-500]="paymentSubmitted && !paymentAddress"
            [class.bg-red-50]="paymentSubmitted && !paymentAddress"
            class="w-full border border-gray-400 rounded-lg px-3 py-2 text-xs focus:border-[var(--primary)] focus:outline-none transition"
            placeholder="Address"
          />
          <p *ngIf="paymentSubmitted && !paymentAddress" class="text-[10px] text-red-500 mt-1 px-1 animate-fadeIn">
            Address is required
          </p>
        </div>
        <div class="relative">
          <input
            type="text"
            [(ngModel)]="paymentPhone"
            [class.border-red-500]="paymentSubmitted && !paymentPhone"
            [class.bg-red-50]="paymentSubmitted && !paymentPhone"
            class="w-full border border-gray-400 rounded-lg px-3 py-2 text-xs focus:border-[var(--primary)] focus:outline-none transition"
            placeholder="Phone"
          />
          <p *ngIf="paymentSubmitted && !paymentPhone" class="text-[10px] text-red-500 mt-1 px-1 animate-fadeIn">
            Phone is required
          </p>
        </div>
      </div>

      <div class="mb-6">
        <h3 class="font-bold mb-2 text-gray-800 flex items-center gap-2 px-1 text-sm">
          <span class="text-lg">🎟️</span> Selected Tickets ({{selectedTickets.length}})
        </h3>
        <div class="border border-gray-400 rounded-xl p-4 h-40 overflow-auto text-sm bg-white scrollbar-thin">
          <div class="flex flex-wrap gap-x-4 gap-y-2">
            <div *ngFor="let ticket of selectedTickets" class="font-medium text-gray-700">
              {{ ticket.alphabet }}{{ ticket.number }}
            </div>
          </div>
          <div *ngIf="selectedTickets.length === 0" class="text-gray-400 text-center mt-8">
            No tickets selected
          </div>
        </div>
      </div>

      <div class="mb-6">
        <h3 class="font-bold mb-2 text-gray-800 flex items-center gap-2 px-1 text-sm">
          <span class="text-lg">💳</span> Payment Method
        </h3>
        <div class="flex flex-wrap gap-3">
          <div
            *ngFor="let card of allCards"
            (click)="onCardClick(card)"
            class="cursor-pointer min-w-[100px] rounded-xl p-3 text-center border transition-all duration-300 flex flex-col items-center justify-center gap-1"
            [ngClass]="
              selectedCard?.id === card.id
                ? 'border-[var(--primary)] bg-[var(--primary)] shadow-lg'
                : 'border-gray-200 hover:border-[var(--primary)] bg-white'
            "
          >
            <div class="w-12 h-12 rounded-lg bg-white flex items-center justify-center p-2 overflow-hidden shadow-sm">
              <img [src]="card.icon" class="w-full h-full object-contain" />
            </div>
            <p class="text-[10px] font-bold uppercase tracking-wider" [class.text-white]="selectedCard?.id === card.id" [class.text-gray-600]="selectedCard?.id !== card.id">
              {{ card.name }}
            </p>
          </div>
        </div>
      </div>

      <div class="flex flex-col sm:flex-row items-stretch justify-center gap-4 mt-6 max-w-md mx-auto">
        <div *ngIf="randomOneAccount" class="payment-card-section animate-slideUp">
        
          <div class="qr-container cursor-zoom-in" (click)="openFullQR()">
            <img *ngIf="randomOneAccount.t1" [src]="randomOneAccount.t1" alt="QR Code" class="qr-image" />
            <div *ngIf="!randomOneAccount.t1" class="qr-placeholder">
              <i class="fa-solid fa-qrcode text-3xl text-gray-300"></i>
            </div>
          </div>
        </div>

        <div class="payment-card-section animate-slideUp" [style.animation-delay]="'0.1s'">
          
          <div
            class="upload-box group"
            (click)="triggerFileInput()"
            [class.has-image]="imagePreview"
          >
            <div class="upload-content text-center">
              <div class="upload-icon-wrapper mb-1">
                <i class="fa-solid fa-arrow-up-from-bracket text-gray-400 group-hover:text-[var(--primary)] transition text-sm"></i>
              </div>
              <p class="text-[10px] font-medium text-gray-500 group-hover:text-gray-700">Upload Screenshot</p>
            </div>
            
            <div *ngIf="imagePreview" class="preview-overlay animate-fadeIn">
              <img [src]="imagePreview" class="preview-thumb" />
              <div class="overlay-hint">
                <i class="fa-solid fa-repeat text-white text-xs"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <input
        type="file"
        #fileInput
        accept="image/*"
        style="display: none"
        (change)="onFileSelected($event)"
      />

      <div class="flex items-center gap-3 mt-8 pt-6 border-t border-gray-100">
        <button (click)="clsoeButtonClick()" class="flex-1 py-2 text-xs font-bold border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors uppercase tracking-widest text-gray-500">
          Cancel
        </button>
        <button
          class="flex-1 py-2 text-xs font-bold bg-[#1e293b] text-white rounded-lg cursor-pointer flex items-center justify-center gap-2 hover:bg-[#0f172a] shadow-lg hover:shadow-xl transition-all disabled:bg-gray-400 disabled:cursor-not-allowed uppercase tracking-widest"
          (click)="confirmPayment()"
          [disabled]="loadingPayment"
        >
          <span
            *ngIf="loadingPayment"
            class="animate-spin inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full"
          ></span>
          {{
            loadingPayment ? 'Processing...' : 'Confirm'
          }}
        </button>
      </div>
    </div>
  </div>
</div>

<div 
  *ngIf="isQRFullScreen && randomOneAccount?.t1" 
  class="qr-lightbox"
  (click)="closeFullQR()"
>
  <div class="qr-lightbox-content animate-zoomIn" (click)="$event.stopPropagation()">
    <button class="qr-lightbox-close" (click)="closeFullQR()">
      <i class="fa-solid fa-xmark"></i>
    </button>
    <img [src]="randomOneAccount.t1" alt="Full QR Code" class="qr-full-image" />
    <p class="text-white text-center mt-4 font-medium">{{ randomOneAccount.name }}</p>
  </div>
</div>
